<h4 class=" d-flex justify-content-between align-items-center font-weight-bold pt-3">
   <span><span class="text-muted font-weight-light">Acordo /</span> Aprovação</span>
 </h4>
 <hr class="border-light my-0">
 <span>AcordoId:</span>{{id}}<br/>
 <span>UsuarioId:</span>{{usuarioId}}<br/>
 <span>Nome:</span>{{nome}}<br/>
 <span>Email:</span>{{nome}}<br/>
 <span>Token:</span>{{token}}
